/**
 * ═══════════════════════════════════════════════════════════════════
 * LA COMPRA PENDIENTE de /franquicias/adquirir (Anahí, 29-ago).
 *
 * "Cuando compren el paquete debe redirigir a /checkout para validar la
 * compra, los datos, la dirección y el tipo de pago. Dependiendo si
 * eligen la franquicia o el paquete."
 *
 * Antes cada botón de esa pantalla cerraba la venta por su cuenta:
 * "Confirmar compra" creaba el pedido con la dirección que hubiera (o
 * ninguna) y "Comprar directo" abría Stripe sin preguntar nada. Eran dos
 * caminos de pago distintos del que usa el resto de la tienda, así que
 * una compra de $15,072 se cerraba con menos datos que una de $3,220.
 *
 * Ahora los dos botones dejan aquí QUÉ se compra y mandan a /checkout,
 * que es la pantalla que ya sabe pedir dirección, teléfono y método de
 * pago, y que ya trata bien los tres métodos.
 *
 * ── En `sessionStorage`, como el borrador de tienda ──────────────────
 * Mismo sitio y por el mismo motivo: la intención de compra muere con la
 * pestaña. En `localStorage` sobreviviría al cierre del navegador y
 * alguien se encontraría un carrito de franquicia de la semana pasada.
 * ═══════════════════════════════════════════════════════════════════
 */
const KEY = "nh_franchise_checkout";

export interface FranchiseCheckoutDraft {
  /** El paquete que se compra. */
  packageId: string;
  /** Para poder pintar el resumen sin volver a pedir el catálogo. */
  packageSlug: string;
  packageName: string;
  packagePriceCents: number;
  /** `true` si además se adquiere la Franquicia Digital. */
  withFranchise: boolean;
  /** Lo que cuesta la franquicia hoy, o 0 si el paquete la incluye. */
  franchisePriceCents: number;
  currency: "MXN" | "USD";
}

export function writeFranchiseCheckout(draft: FranchiseCheckoutDraft): void {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    // Navegación privada: la compra sigue, solo no sobrevive al viaje.
  }
}

export function readFranchiseCheckout(): FranchiseCheckoutDraft | null {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as FranchiseCheckoutDraft;
    // Un borrador sin paquete o sin precio no es un borrador a medias:
    // es basura, y seguir con él pintaría un total de "NaN".
    return parsed?.packageId && typeof parsed.packagePriceCents === "number" ? parsed : null;
  } catch {
    return null;
  }
}

export function clearFranchiseCheckout(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // Nada que limpiar si no se pudo ni guardar.
  }
}
